import { DriveStep } from 'driver.js';
import { THandleTourCloseParams } from './useTutorials.types';

const createRelaunchPortalToursStep = (onComplete: () => void): DriveStep => ({
  element: '#account-icon-button',
  popover: {
    title: '🧭 Relaunch Portal tours',
    description: `<p>You can always relaunch the tours by <strong>clicking your profile icon.</strong></p>
      <p>We hope you enjoy using the Portal!</p>`,
    side: 'bottom',
    align: 'end',
    nextBtnText: 'Got it',
    onNextClick: onComplete,
  },
  disableActiveInteraction: true,
});

export const addRelaunchStepWhenApplicable = (
  steps: DriveStep[],
  enabled: boolean,
  onComplete: () => void,
) => {
  if (!enabled) return;
  steps.push(createRelaunchPortalToursStep(onComplete));
};

export const closeTourOrJumpToFinalStep = ({
  tour,
  autoTriggered,
  onTourComplete,
}: THandleTourCloseParams) => {
  const steps = tour.getConfig()?.steps;
  const activeStep = tour.getActiveStep();

  if (!steps || steps.length === 0) {
    tour.destroy();
    return;
  }

  if (autoTriggered && onTourComplete) {
    onTourComplete();
  }

  const lastStepIndex = steps.length - 1;

  const activeStepIndex =
    activeStep &&
    steps.findIndex(
      (step) =>
        step.element === activeStep.element &&
        step.popover?.title === activeStep.popover?.title,
    );

  if (activeStepIndex === lastStepIndex) {
    tour.destroy();
  } else {
    tour.moveTo(lastStepIndex);
  }
};
